<template>
  <b-modal
        scrollable
    id="create-order-movement-number-internal"
    ref="modal"
    header-class="headerModal"
    centered
    size="xl"
    :title="`${$t('CreateOrderMovementInternal')}`"
    hide-footer
    @hide="onCancel"
  >
    <p
      v-if="(productsInStockList.length == 0 && orderItemIds.length == 0) && buttonSubmited"
      style="color:red;"
    >
      {{ $t('ChoseOrderOrArticles') }}
    </p>
    <div
      :class="productsInStockList.length > 0 ? 'articles-found' : 'no-article-found'"
    >
      <h4>
        {{ $t('Articles') }}
      </h4>
      <LoadingWrapperSpinner
        :response-data="productsInStockList"
        :class="productsInStockList.length > 0 ? 'display-all-articles' : 'no-articles'"
      >
        <div
          v-for="(articles, index) in productsInStockList"
          :key="index"
          class="display-articles"
        >
          <div style="text-align:right;">
            <b-icon-trash
              style="cursor:pointer;"
              @click="removeProduct(index)"
            />
          </div>
          <b-form-group
            :label="$t('ArticleNumber')"
          >
            <b-form-input
              v-model="articles.articleNumber"
              disabled
            />
          </b-form-group>
          <b-form-group
            :label="$t('Amount')"
          >
            <b-form-input
              v-model.number="articles.amount"
            />
          </b-form-group>
          <b-form-group
            :label="$t('Notes')"
          >
            <b-form-textarea
              v-model="articles.notes"
            />
          </b-form-group>
        </div>
      </LoadingWrapperSpinner>
    </div>
    <div
      :class="orderItemIds.length > 0 ? 'articles-found' : 'no-article-found'"
      style="margin-top:10px;"
    >
      <h4>
        {{ $t('Orders') }}
      </h4>
      <LoadingWrapperSpinner
        :response-data="orderItemIds"
        :class="orderItemIds.length > 0 ? 'display-all-articles' : 'no-articles'"
      >
        <div
          v-for="(orders, index) in orderItemIds"
          :key="index"
          class="display-articles"
        >
          <div style="text-align:right;">
            <b-icon-trash
              style="cursor:pointer;"
              @click="removeOrder(index)"
            />
          </div>
          <b-form-group
            :label="$t('OrderNumber')"
          >
            <b-form-input
              v-model="orders.orderNumber"
              disabled
            />
          </b-form-group>
          <b-form-group
            :label="$t('ArticleNumber')"
          >
            <b-form-input
              v-model="orders.articleNumber"
              disabled
            />
          </b-form-group>
        </div>
      </LoadingWrapperSpinner>
    </div>
    <div
      class="display-elements"
    >
      <b-form-group
        :label="$t('deliverDate')"
      >
        <date-picker
          v-model="deliverDate"
          type="date"
          :placeholder="$t('SelectD')"
          value-type="format"
          format="YYYY-MM-DD"
          :clearable="false"
          style="width:100%"
        />
      </b-form-group>
      <b-form-group
        :label="$t('Filiale')"
      >
        <b-form-input
          v-model="filiale.storeName"
          disabled
          style="width:100%"
        />
      </b-form-group>
      <b-form-group
        :label="$t('FromLocation')"
        style="width:100%"
      >
        <vue-select
          v-model="fromLocation"
          :options="getLocationsByStoreIdName"
          label="locationName"
          :reduce="(e) => e.locationId"
          :placeholder="$t('SelectLocation')"
          style="width: 100%; min-width: 100%; max-width: 100%;"
        />
        <p
          v-if="fromLocation == null && buttonSubmited"
          style="color:red;"
        >
          {{ $t('SelectLocation') }}
        </p>
      </b-form-group>
      <b-form-group
        :label="$t('ToLocation')"
        style="width:100%"
      >
        <vue-select
          v-model="toLocation"
          :options="getLocationsByStoreIdName"
          label="locationName"
          :reduce="(e) => e.locationId"
          :placeholder="$t('SelectLocation')"
          style="width: 100%; min-width: 100%; max-width: 100%;"
          @input="updateResponsibleUser"
        />
        <p
          v-if="toLocation == null && buttonSubmited"
          style="color:red;"
        >
          {{ $t('SelectLocation') }}
        </p>
      </b-form-group>
      <b-form-group
        :label="$t('ResponsibleUser')"
        style="width:100%"
      >
        <vue-select
          v-model="userId"
          :options="getRegularEmployeesById"
          label="name"
          :reduce="(e) => e.userId"
          :placeholder="$t('Select')"
          style="width: 100%; min-width: 100%; max-width: 100%;"
        />
      </b-form-group>
    </div>
    <p
      v-if="filiale.storeId == null"
      style="color:red;margin-bottom:0px;"
    >
      {{ $t('SelectStoreToCreateOrderMovement') }}
    </p>
    <div
      class="buttonsEverywhere"
      style="margin-top:1%;"
    >
      <button
        type="button"
        variant="none"
        class="buttonSubmit"
        :disabled="filiale.storeId == null"
        @click="onSubmit"
      >
      <div
          v-if="loading"
          style="width:100%"
          class="pdf-spinner-overlay"
        >
          <span class="loader" />
        </div>
        {{ $t('Submit') }}
      </button>
      <b-button
        type="reset"
        variant="danger"
        class="buttonCancel"
        style="margin-right: 15px; background: white; color: black; border-color: white;font-weight: 400;"
        @click="onCancel"
      >
        {{ $t('Cancel') }}
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';


export default {
  components: {
    DatePicker,
  },
  props: ['productsInStockList', 'orderItemIds', 'filiale'],
  data() {
    return {
      buttonSubmited: false,
      loading: false,
      deliverDate: moment().format('YYYY-MM-DD'),
      fromLocation: null,
      toLocation: null,
      userId: null,
    }
  },
  computed: {
    ...mapGetters([
      'getLocationsByStoreIdName',
      'getUsersByMultipleRoles',
      'getRegularEmployeesById',
    ]),
  },
  mounted() {
    this.loadUsersByMultipleRoles({
      status: true,
      object: ['Manager'],
    })
  },
  methods: {
    ...mapActions([
      'loadCreateOrderMovementInternal',
      'loadUsersByMultipleRoles',
      'loadRegularEmployeesId',
      'resetLoadRegularEmployeesId',
    ]),
    updateResponsibleUser(value) {
      if (value.storeId !== null) {
        this.userId = null
        this.loadRegularEmployeesId({
          storeId: value.storeId,
        })
      } else {
        this.userId = null
        this.resetLoadRegularEmployeesId()
      }
    },
    removeProduct(index) {
      this.productsInStockList.splice(index, 1);
    },
    removeOrder(index) {
      this.orderItemIds.splice(index, 1);
    },
    async onSubmit() {
      this.buttonSubmited = true
      if (this.fromLocation === null) {
        return
      }
      if (this.toLocation === null) {
        return
      }
      if (this.productsInStockList.length == 0 && this.orderItemIds.length == 0) {
        return
      }
      try {
        this.loading = true
        const object = {
          deliverDate: this.deliverDate,
          deliverLocationId: this.filiale.storeId,
          receiverLocationId: this.fromLocation,
          userId: this.userId,
          lineItemMovementIds: this.orderItemIds.map((item) => { return item.lineItemMovementId }),
          materialVariantMovementRequestDtos: [],
          productInStockWithNotes: this.productsInStockList.map((item) => {
            return {
              productInStockMovementId: item.productInStockMovementId,
              amount: item.amount,
              notes: item.notes,
            }
          }),
        }
        await this.loadCreateOrderMovementInternal({
          object,
          successCallback: () => {
            this.loading = false
            this.$refs.modal.hide();
            this.onReset();
            this.$emit('updateOrderAndArticle');
          },
        });
      } catch (error) {
        this.loading = false
      }
    },
    onCancel() {
      this.onReset();
      this.$emit('removeListsOrderArticle');
    },
    onReset() {
      this.buttonSubmited = false
      this.userId = null
      this.fromLocation = null
      this.toLocation = null
      this.loading = false
      this.deliverDate = moment().format('YYYY-MM-DD')
      this.$refs.modal.hide();
    },
  },
}
</script>

  <style lang="scss" scoped>
      .display-articles {
          border: 1px solid lightgrey;
          border-radius:12px;
          padding: 10px;
      }
      .display-all-articles {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 8px;
      }
      .no-articles {
          text-align:left;
      }
      .no-article-found {
          border: 1px solid lightgrey;
          border-radius:12px;
          padding: 10px;
      }
      .articles-found {
          padding: 10px;
          border: 1px solid lightgrey;
          border-radius:12px;
      }
      .display-elements {
          border: 1px solid lightgrey;
          border-radius:12px;
          padding: 10px;
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 5px;
          margin-top:10px;
      }
  </style>
